<template>
  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" min-width="auto" offset-y transition="scale-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="time"
        :clearable="clearable"
        :disabled="saving"
        :label="label"
        hide-details
        readonly
        v-bind="{ ...attrs, ...inputStyles }"
        @click:clear="$emit('change', null)"
        v-on="on"
      >
        <template v-if="!prependInnerIcon" slot="prepend">
          <v-icon>mdi-clock-outline</v-icon>
        </template>
        <template v-if="prependInnerIcon" slot="prepend-inner">
          <v-icon class="mr-2">{{ prependInnerIcon }}</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-time-picker v-if="menu" :value="time" color="primary" format="24hr" @input="v => $emit('change', v)" @click:minute="menu = false" />
  </v-menu>
</template>

<script>
// Kellonajan valinta DatePickerin tapaan: lukukenttä avaa v-time-pickerin valikkoon. Arvo on 'HH:mm' tai null.
export default {
  name: 'TimePicker',
  props: {
    time: String,
    label: String,
    inputStyles: Object,
    saving: Boolean,
    prependInnerIcon: String,
    clearable: Boolean,
  },
  data() {
    return {
      menu: false,
    };
  },
};
</script>

<style scoped></style>
